import * as React from 'react';
import MediaElement from './MediaElement';
const VideoGrid = ({ videos }) => {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {videos.map((video) => <MediaElement key={video.id} video={video} additionalClassName={'xl:w-72'}/>)}
    </div>;
};
VideoGrid.displayName = 'VideoGrid';
export default VideoGrid;
